import { Section } from "../components/Section";
import { LEGAL_ENTITY } from "../content/legal";
import { usePageMeta } from "../lib/usePageMeta";

/**
 * Where non-Australian traffic lands.
 *
 * ⚠️ THIS PAGE IS NOT THE CONTROL. The enforcement is the `AustraliaOnly` WAF
 * rule pair in RIPK/api/cdk/lib/kev-edge-stack.ts: one blocks /api/* outright
 * for non-AU viewers, the other 302s document requests here. A React route
 * cannot gate anything — it ships to the browser, and anyone who can open
 * devtools can walk around it. This is only the explanation the redirect lands
 * on. If the WAF rules are ever removed, removing this page does not make the
 * site any less open; wiring geo-detection into the SPA would not make it any
 * more closed.
 *
 * NO LINK BACK TO "/" — that is the loop. The redirect sends document requests
 * here, so a "back to the front" button walks the reader straight into another
 * 302 and looks broken. The only links out are the legal documents, which stay
 * readable from anywhere on purpose: someone refused service is exactly who has
 * a reason to read the terms.
 *
 * The copy makes NO promise about other countries later. "Coming soon to your
 * region" is a representation about future conduct, and this is a licensing
 * position, not a roadmap.
 */
export function Unavailable() {
  usePageMeta("unavailable");

  return (
    <Section
      heading="Australia only"
      eyebrow="Not available here"
      tone="ink"
      level={1}
      heroScroll
    >
      <div style={{ maxWidth: "58ch", color: "var(--body)", display: "grid", gap: 20 }}>
        <p>
          {LEGAL_ENTITY.tradingName} is operated from Australia and is available only to
          people in Australia. Your connection looks like it&rsquo;s coming from somewhere
          else, so the service isn&rsquo;t available to you.
        </p>
        <p>
          If you <em>are</em> in Australia, your traffic may be routing through another
          country — a VPN, a work network, or a mobile carrier that hands off overseas.
          Turn that off and reload the page.
        </p>
        <p>
          Anything else, email{" "}
          <a href={`mailto:${LEGAL_ENTITY.contactGeneral}`}>{LEGAL_ENTITY.contactGeneral}</a>.
          You can still read our{" "}
          <a href="/legal/terms">Terms of Service</a> and{" "}
          <a href="/legal/privacy">Privacy Policy</a>.
        </p>
      </div>
    </Section>
  );
}
